export default __webpack_public_path__ + "static/media/walkthrough-5.f116bd80.png";